<script>
	import { Line } from 'vue-chartjs'


	export default {
	  extends: Line,
	  data () {
	  	return {
	  		chart_options: {
		    	scales: {
	                yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
	            },
                responsive: true,
                maintainAspectRatio: false
	  		},
	  		datas: {}
	  	}
	  },
	  mounted () {
	  	this.fetchDatas();
	    // Overwriting base render method with actual data.
	  },
	  methods: {
	  	fetchDatas(filters = "") {
	  		axios
		      .get(this.url+"?filters="+filters)
		      .then(response => {
		      	this.datas = response.data;
		    	this.renderChart(this.datas, this.chart_options);
		      });

		 },
		 changeUrl(newUrl){
            this.url = newUrl;
            this.fetchDatas();
        },
	  },
	  props: {
	  	url: {
	  		type: String,
	  		requred: true
	  	}
	  }

	}
</script>